import { render, staticRenderFns } from "./SurgeryInfo.vue?vue&type=template&id=116bf4de&scoped=true&"
import script from "./SurgeryInfo.vue?vue&type=script&lang=js&"
export * from "./SurgeryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116bf4de",
  null
  
)

export default component.exports